{
  "el": {
    "sortGroups": {
      "date": "Ημερομηνία",
      "deadline": "Προθεσμία",
      "name": "Όνομα"
    },
    "sorting": {
      "category_name_asc": "Κατηγορία Α → Ω",
      "category_name_desc": "Κατηγορία Ω → Α",
      "created_at_asc": "Παλαιότερα πρώτα",
      "created_at_desc": "Νεότερα πρώτα",
      "deadline_date_asc": "Πιο μακρινή προθεσμία πρώτα",
      "deadline_date_desc": "Πιο κοντινή προθεσμία πρώτα",
      "due_date asc": "Πιο μακρινή προθεσμία πρώτα",
      "due_date desc": "Πιο κοντινή προθεσμία πρώτα",
      "group_name asc": "Όνομα Α → Ω",
      "group_name desc": "Όνομα Ω → Α",
      "group_name_asc": "Όνομα Α → Ω",
      "group_name_desc": "Όνομα Ω → Α",
      "last_name_asc": "Επώνυμο Α → Ω",
      "last_name_desc": "Επώνυμο Ω → Α",
      "messaged_all_at_nulls_first_asc": "Παλαιότερα πρώτα",
      "messaged_all_at_nulls_last_desc": "Νεότερα πρώτα",
      "messaged_at_nulls_first_asc": "Παλαιότερα πρώτα",
      "messaged_at_nulls_last_desc": "Νεότερα πρώτα",
      "name_asc": "Όνομα Α → Ω",
      "name_desc": "Όνομα Ω → Α",
      "name_lower asc": "Όνομα Α → Ω",
      "name_lower desc": "Όνομα Ω → Α",
      "name_lower_asc": "Όνομα Α → Ω",
      "name_lower_desc": "Όνομα Ω → Α",
      "notification_level_name_asc": "Ακίνητο Α → Ω",
      "notification_level_name_asc_sup": "Έργο Α → Ω",
      "notification_level_name_desc": "Ακίνητο Ω → Α",
      "notification_level_name_desc_sup": "Έργο Ω → Α",
      "session_started_at_asc": "Παλαιότερη έναρξη συνεδρίας πρώτα",
      "session_started_at_desc": "Νεότερη έναρξη συνεδρίας πρώτα",
      "status asc": "Κατάσταση Α → Ω",
      "status desc": "Κατάσταση Ω → Α",
      "status_name_asc": "Κατάσταση Α → Ω",
      "status_name_desc": "Κατάσταση Ω → Α",
      "unit_name_asc": "Ακίνητο Α → Ω",
      "unit_name_desc": "Ακίνητο Ω → Α",
      "unit_name_lower_asc": "Ακίνητο Α → Ω",
      "unit_name_lower_desc": "Ακίνητο Ω → Α",
      "updated_at asc": "Λιγότερο πρόσφατα ενημερωμένα",
      "updated_at desc": "Πρόσφατα ενημερωμένα",
      "updated_at_asc": "Λιγότερο πρόσφατα ενημερωμένα",
      "updated_at_desc": "Πρόσφατα ενημερωμένα"
    }
  }
}
